<template>
  <base-section
  id="hero"
  space="0"
  >
    <v-img
      :max-height="minHeight"
      :src="require('@/assets/lyon_bg.jpg')"
      gradient="to bottom, rgba(0, 51, 153, 100), rgba(255,255,255,.2)"
    >
      <v-container class="fill-height">
        <v-responsive
          class="d-flex align-center mx-auto"
          height="100%"
          width="100%"
        >
        <!--
          <v-img
          :src="require('@/assets/logo.png')"
          max-height="150"
          width="100%"
          contain
          id="img2"
          />
        -->
          <base-heading
            size="text-h2"
            weight="bold"
            id="heading1"
            title="28th IEEE International Symposium on Design and Diagnostics of Electronic Circuits and Systems (DDECS)"
          />

          <base-subheading
            size="text-h3"
            weight="bold"
            id="heading2"
            title="May 5-7 in Lyon, France"
          />
          <div
            :class="'flex-column align-start'"
            class="d-flex flex-wrap"
          >
          <span class="font-weight-bold ml-6 mr-4 my-4"></span>
          <!---
            <base-btn
            href="LATS24_cfp.pdf"
            target="_blank"
            download
            >
              Call for Papers
            </base-btn>
          --->
          <v-badge
            bordered
            color="accent"
            overlap
          >
            <base-btn
            to="cfp"
            >
              Call for Papers
            </base-btn>
          </v-badge>
        </div>
        </v-responsive>
      </v-container>
    </v-img>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: false },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '100vh'
        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
    },
  }
</script>

<style>
#heading1, #heading2 {
  color: white !important;
  text-shadow: 2px 2px 1px black;
}
#img1 > .v-image__image, #img2 > .v-image__image {
  background-position: unset !important;
}
</style>
